import React from "react";

const MAX_TEXTOS = 10;
const MAX_CARACTERES = 300;

const TextosLibresConfig = ({ config, setConfig }) => {
  const textosLibres = Array.isArray(config.textosLibres)
    ? config.textosLibres
    : [];

  const generarId = () => {
    if (typeof crypto !== "undefined" && crypto.randomUUID) {
      return crypto.randomUUID();
    }

    return `texto-${Date.now()}-${Math.random()}`;
  };

  const agregarTexto = () => {
    if (textosLibres.length >= MAX_TEXTOS) return;

    const nuevoTexto = {
      id: generarId(),
      texto: "",
      margenX: 0,
      margenY: 0,
      tamañoLetra: 12,
      fuente: "Arial",
      color: "#000000",
      bold: false,
    };

    setConfig((prev) => ({
      ...prev,
      textosLibres: [
        ...(Array.isArray(prev.textosLibres) ? prev.textosLibres : []),
        nuevoTexto,
      ],
    }));
  };

  const actualizarTexto = (id, campo, valor) => {
    setConfig((prev) => ({
      ...prev,
      textosLibres: (prev.textosLibres || []).map((item) =>
        item.id === id
          ? {
              ...item,
              [campo]: valor,
            }
          : item
      ),
    }));
  };

  const eliminarTexto = (id) => {
    setConfig((prev) => ({
      ...prev,
      textosLibres: (prev.textosLibres || []).filter(
        (item) => item.id !== id
      ),
    }));
  };

  const moverTexto = (id, campo, cantidad) => {
    setConfig((prev) => ({
      ...prev,
      textosLibres: (prev.textosLibres || []).map((item) => {
        if (item.id !== id) return item;

        const valorActual = Number(item[campo]) || 0;

        return {
          ...item,
          [campo]: Number((valorActual + cantidad).toFixed(2)),
        };
      }),
    }));
  };

  return (
    <div className="textos-libres-config">
      <div className="textos-libres-header">
        <div>
          <h3>Texto adicional</h3>
          <p>
            Agrega texto adicional personalizado para tu receta, máximo {MAX_TEXTOS}.
          </p>
        </div>

        <button
          type="button"
          className="agregar-texto-libre"
          onClick={agregarTexto}
          disabled={textosLibres.length >= MAX_TEXTOS}
        >
          + Agregar texto
        </button>
      </div>

      {textosLibres.length === 0 && (
        <div className="textos-libres-vacio">
          No has agregado textos personalizados.
        </div>
      )}

      {textosLibres.map((item, index) => (
        <div className="texto-libre-card" key={item.id}>
          <div className="texto-libre-card-header">
            <strong>Texto libre {index + 1}</strong>

            <button
              type="button"
              className="eliminar-texto-libre"
              onClick={() => eliminarTexto(item.id)}
              title="Eliminar texto"
              aria-label={`Eliminar texto libre ${index + 1}`}
            >
              ×
            </button>
          </div>

          <label className="texto-libre-contenido">
            Texto
            <textarea
              value={item.texto}
              maxLength={MAX_CARACTERES}
              onChange={(e) =>
                actualizarTexto(item.id, "texto", e.target.value)
              }
              placeholder="Escribe aquí el texto que quieras mostrar en la receta..."
            />
          </label>

          <div className="contador-texto-libre">
            {item.texto.length}/{MAX_CARACTERES}
          </div>

          <div className="control-posicion">
            <div className="control-posicion-titulo">Posición</div>

            <div className="control-posicion-contenido">
              <div className="control-posicion-flechas">
                <span />

                <button
                  type="button"
                  className="boton-flecha-posicion"
                  onClick={() =>
                    moverTexto(item.id, "margenY", -0.1)
                  }
                  title="Mover arriba"
                >
                  ↑
                </button>

                <span />

                <button
                  type="button"
                  className="boton-flecha-posicion"
                  onClick={() =>
                    moverTexto(item.id, "margenX", -0.1)
                  }
                  title="Mover izquierda"
                >
                  ←
                </button>

                <span className="centro-posicion" />

                <button
                  type="button"
                  className="boton-flecha-posicion"
                  onClick={() =>
                    moverTexto(item.id, "margenX", 0.1)
                  }
                  title="Mover derecha"
                >
                  →
                </button>

                <span />

                <button
                  type="button"
                  className="boton-flecha-posicion"
                  onClick={() =>
                    moverTexto(item.id, "margenY", 0.1)
                  }
                  title="Mover abajo"
                >
                  ↓
                </button>

                <span />
              </div>

              <div className="ajuste-preciso-posicion">
                <div className="ajuste-preciso-titulo">
                  Ajuste manual
                </div>

                <div className="ajuste-preciso-inputs">
                  <label>
                    <span>X</span>
                    <input
                      type="number"
                      step="0.01"
                      value={item.margenX}
                      onChange={(e) =>
                        actualizarTexto(
                          item.id,
                          "margenX",
                          parseFloat(e.target.value) || 0
                        )
                      }
                    />
                  </label>

                  <label>
                    <span>Y</span>
                    <input
                      type="number"
                      step="0.01"
                      value={item.margenY}
                      onChange={(e) =>
                        actualizarTexto(
                          item.id,
                          "margenY",
                          parseFloat(e.target.value) || 0
                        )
                      }
                    />
                  </label>
                </div>
              </div>
            </div>
          </div>

          <div className="texto-libre-formato">
            <label>
              Tamaño de letra
              <input
                type="number"
                min="8"
                max="24"
                step="1"
                value={item.tamañoLetra}
                onChange={(e) =>
                  actualizarTexto(
                    item.id,
                    "tamañoLetra",
                    parseInt(e.target.value, 10) || 12
                  )
                }
              />
            </label>

            <label>
              Tipo de letra
              <select
                value={item.fuente}
                onChange={(e) =>
                  actualizarTexto(item.id, "fuente", e.target.value)
                }
              >
                <option value="Arial">Arial</option>
                <option value="Helvetica">Helvetica</option>
                <option value="Times New Roman">Times New Roman</option>
                <option value="Georgia">Georgia</option>
                <option value="Verdana">Verdana</option>
                <option value="Trebuchet MS">Trebuchet MS</option>
                <option value="Tahoma">Tahoma</option>
                <option value="Courier New">Courier New</option>
                <option value="Comic Sans MS">Comic Sans MS</option>
                <option value="Lucida Console">Lucida Console</option>
                <option value="Lucida Sans">Lucida Sans</option>
                <option value="Cursive">Cursive</option>
                <option value="Brush Script MT">Brush Script MT</option>
                <option value="Lucida Handwriting">Lucida Handwriting</option>
                <option value="Segoe Script">Segoe Script</option>
                <option value="Monotype Corsiva">Monotype Corsiva</option>
              </select>
            </label>

            <label>
              Color
              <input
                type="color"
                value={item.color}
                onChange={(e) =>
                  actualizarTexto(item.id, "color", e.target.value)
                }
              />
            </label>

            <label>
              Negritas
              <input
                type="checkbox"
                checked={item.bold}
                onChange={(e) =>
                  actualizarTexto(item.id, "bold", e.target.checked)
                }
              />
            </label>
          </div>
        </div>
      ))}

      {textosLibres.length >= MAX_TEXTOS && (
        <div className="limite-textos-libres">
          Alcanzaste el máximo de {MAX_TEXTOS} textos libres.
        </div>
      )}
    </div>
  );
};

export default TextosLibresConfig;